'use client';

import React from 'react';

import { Body, Heading } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { Container } from '@/components/Container';
import { getIconSrc, SAFETY_STEPS } from '@/constants/safetyLanding';

export function HowDepopKeepsYouSafe() {
  const t = useTranslations('safety');

  return (
    <section className={styles.section}>
      <Container className={styles.container}>
        <div className={styles.header}>
          <Heading variant="xl" as="h2">
            {t('SafetyPage.HowItWorks.Title')}
          </Heading>
        </div>
        <ul className={styles.stepsList}>
          {SAFETY_STEPS.map((step) => (
            <li key={step.titleKey} className={styles.stepItem}>
              <div className={styles.stepCard}>
                <div className={styles.stepIconWrapper}>
                  <img
                    src={getIconSrc(t(step.icon))}
                    alt=""
                    aria-hidden="true"
                    className={styles.stepIcon}
                  />
                </div>
                <div className={styles.stepContent}>
                  <Heading variant="md" as="h3">
                    {t(step.titleKey)}
                  </Heading>
                  <Body variant="md-regular">{t(step.descriptionKey)}</Body>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
}
